import { createClient } from "@supabase/supabase-js";
import { getEnv } from "./env";

const env = getEnv();

export const supabase = createClient(env.supabaseUrl, env.publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: "golighthub-admin-session",
  },
});
